import { Icon } from '../ui/Icon';
import { Button, Card } from '../ui/primitives';
import type { InventoryView } from '../../utils/reports/inventoryView';
import { ReportsNotes, ReportsSay } from './ReportsParts';
import { ReportsDetail, ReportsEmpty, ReportsSection, ReportsStats } from './ReportsPieces';

/**
 * P-084 · R6 «¿Cómo está mi inventario?». Solo dibuja `InventoryView`: la frase, cuatro cifras, «Requiere atención»
 * (la definición única de riesgo) y el detalle con lo que se movió, mermas y compras, y lo que no se movió.
 */
export function ReportInventory({ view, onNavigate }: { view: InventoryView; onNavigate: (destination: string) => void }) {
  if (view.empty) {
    return (
      <>
        <ReportsSay segments={view.say} />
        <ReportsEmpty description={view.empty.description} title={view.empty.title} />
        <ReportsNotes notes={view.notes} />
      </>
    );
  }
  return (
    <>
      <ReportsSay segments={view.say} />
      <Card aria-labelledby="reports-inventory-stats" as="section">
        <h2 className="n3-visually-hidden" id="reports-inventory-stats">Por acabarse, agotados, en negativo y valor</h2>
        <ReportsStats stats={view.stats} />
      </Card>
      <ReportsSection icon="inventory" onNavigate={onNavigate} section={view.attention} tone="success" />
      <ReportsDetail id="reports-inventory-detail">
        {view.detail.map((section) => <ReportsSection icon="movements" key={section.key} onNavigate={onNavigate} section={section} tone="success" />)}
      </ReportsDetail>
      <Button className="n3-reports__cta" iconEnd={<Icon name="chevron-right" size={16} />} onClick={() => onNavigate('inventory/stock')} variant="ghost">Ver inventario</Button>
      <ReportsNotes notes={view.notes} />
    </>
  );
}
